import React, { useCallback } from 'react';
import { Col, Row } from 'react-bootstrap';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { BuscaProduto, InputSelect } from '~/components/NovosInputs';
import ToggleDefault from '~/components/ToggleDefault';
import { formatCurrencyAsTex3 } from '~/utils/functions';
import { useAjusteDePara } from '../../hooks/useAjusteDePara';
import { Colunm, ColunmHead, Table } from './styles';
import { getInfos } from '../../services/getInfos';
import { defaultProdTable } from '../../defaultData';
import { toast } from 'react-toastify';

export const FormProdOrigem: React.FC = () => {
  const {
    formTela: {
      register,
      control,
      formState: { errors },
      setValue,
      clearErrors,
    },
    isUpdate,
    prodTable,
    setProdTable,
    tipoAjusteSaida,
    manterDados,
    handleManterDados,
    setProdDerivado,
    selectedLoja,
    handleFocusInput,
  } = useAjusteDePara();
  const { getProdDerivados } = getInfos;

  const handleAddProduto = useCallback(
    async (selected: any) => {
      if (selected.val_custo_rep <= 0) {
        return toast.warn('Produto selecionado não tem o custo informado');
      }
      setProdTable({
        cod_produto: selected.cod_produto,
        des_produto: selected.des_produto,
        qtd_est_atual: selected.qtd_est_atual,
        un_venda: selected.des_unidade_venda,
        un_compra: selected.des_unidade_compra,
        val_peso_emb: selected.val_peso_emb,
      });

      const { success, data } = await getProdDerivados(
        selectedLoja,
        selected.cod_produto,
      );

      if (success) {
        const derivados = data.map((i) => {
          const { cod_produto, des_produto } = i;
          return {
            value: `${cod_produto}`,
            label: `${cod_produto} - ${des_produto}`,
          };
        });
        setProdDerivado(derivados);
        setValue('qtd_ajuste', '');
        handleFocusInput('cod_tipo_ajuste_origem');
        if (data.length === 1) {
          setValue('cod_produto_derivado', {
            value: data[0].cod_produto,
            label: `${data[0].cod_produto} - ${data[0].des_produto}`,
          });
          setValue('cod_tipo_ajuste_derivado', {
            value: data[0].cod_tipo_ajuste,
            label: `${data[0].cod_tipo_ajuste} - ${data[0].des_operacao} ${data[0].des_ajuste}`,
          });
          clearErrors('cod_produto_derivado');
          return clearErrors('cod_tipo_ajuste_derivado');
        }
      }
    },
    [
      getProdDerivados,
      setProdTable,
      selectedLoja,
      setProdDerivado,
      setValue,
      handleFocusInput,
      clearErrors,
    ],
  );

  const onCancelProduct = () => {
    setValue('qtd_ajuste', '');
    setValue('qtd_derivado', '');
    setProdTable(defaultProdTable);
    setProdDerivado([]);
    handleFocusInput('busca_produto');
  };

  return (
    <>
      <Row className="align-items-end mt-3">
        <Col style={{ flex: 1 }}>
          <BuscaProduto
            label="Buscar Produto Origem *"
            name="busca_produto"
            placeholder="Selecione..."
            customOptions={{
              hideBuscarPor: true,
              showSelecionarItensContendo: false,
              buscarPor: ['Produto'],
              buscaDerivados: true,
            }}
            register={register}
            control={control}
            disabled={prodTable.cod_produto !== '' || isUpdate}
            setValue={setValue}
            buscaNasLojas={selectedLoja}
            isError={!!errors.busca_produto}
            getProduct={(selected: any) => {
              handleAddProduto(selected[0]);
            }}
          />
        </Col>
        <Col xs="auto">
          <CustomButtonNovo
            type="button"
            variant="error"
            style={{ backgroundColor: '#dc3545', marginTop: '1.69rem' }}
            label="Cancelar"
            disabled={isUpdate}
            onClick={onCancelProduct}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col sm={12} md={12}>
          <Table>
            <thead style={{ fontWeight: 'normal' }}>
              <tr>
                <ColunmHead align="right">Código</ColunmHead>
                <ColunmHead align="right">Descrição</ColunmHead>
                <ColunmHead align="right">Estoque Atual</ColunmHead>
                <ColunmHead align="right">UN Venda</ColunmHead>
                <ColunmHead align="right">UN Compra</ColunmHead>
              </tr>
            </thead>
            <tbody>
              <tr>
                <Colunm align="center">{prodTable.cod_produto}</Colunm>
                <Colunm align="center" width="700px">
                  {prodTable.des_produto}
                </Colunm>
                <Colunm align="center">
                  {prodTable.cod_produto !== ''
                    ? formatCurrencyAsTex3(prodTable.qtd_est_atual)
                    : ''}
                </Colunm>
                <Colunm align="center">{prodTable.un_venda}</Colunm>
                <Colunm align="center">{prodTable.un_compra}</Colunm>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col sm={12} md={6}>
          <InputSelect
            label="Tipo de Ajuste *"
            name="cod_tipo_ajuste_origem"
            placeholder="Selecione..."
            register={register}
            control={control}
            isError={!!errors.cod_tipo_ajuste_origem}
            options={tipoAjusteSaida}
            disabled={isUpdate}
            changeSelected={(selected) => {
              setValue('cod_tipo_ajuste_origem', selected);
              clearErrors('cod_tipo_ajuste_origem');
              handleFocusInput('qtd_ajuste');
            }}
          />
        </Col>
        <Col sm={12} md={1}>
          <ToggleDefault
            labelText="Manter Dados?"
            setChecked={manterDados}
            onSwitch={() => handleManterDados(!manterDados)}
            disabled={isUpdate}
          />
        </Col>
      </Row>
    </>
  );
};
